import { cx } from 'class-variance-authority';
import NextLink, { type LinkProps as NextLinkProps } from 'next/link';
import type { AnchorHTMLAttributes, ReactNode } from 'react';

type LinkProps = NextLinkProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof NextLinkProps> & {
    children: ReactNode;
    className?: string;
  };

const Link = ({ children, className, ...props }: LinkProps) => {
  return (
    <NextLink className={cx('text-accent hover:text-accent-hover', className)} {...props}>
      {children}
    </NextLink>
  );
};

export default Link;
